import useTranslation from "@/hooks/useTranslation";
import MetricWidget from "../../components/MetricWidget/MetricWidget";
import { useTransportImpactTotals } from "../../hooks/useTransportImpact";
import { ImpactMetric } from "../../utils/types";

export default function TransportImpactTotal({ metric }: { metric: ImpactMetric }) {
  const translation = useTranslation();
  const { data, isLoading, isFetching } = useTransportImpactTotals({ metrics: [metric.key] });

  return (
    <MetricWidget
      title={"Transport footprint"}
      tooltip={translation["dashboard"]["transport"]["total"]}
      loading={isLoading || isFetching}
      metric={metric}
      format={metric.formatter}
      data={{
        value: data?.transport_impact[metric.key],
        comparison: {
          label: "of company total",
          value: data?.company_impact[metric.key],
        },
      }}
    />
  );
}
